// "Mentioned in" — the reverse index, computed in the browser. For the article
// being read, find every OTHER published article that either links to it
// explicitly ([x](article:slug)) or names it in prose. Because it's derived from
// the live article set, a newly published article shows up here automatically,
// with no edits to the older ones.
import { escapeHtml } from "../ui/helpers.js";

function mentions(md, title) {
  if (!title || title.length < 4) return false;
  const re = new RegExp("\\b" + title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\b", "i");
  return re.test(md);
}

export function computeSeeAlso(articles, current, limit = 6) {
  if (!current) return [];
  const slug = current.slug;
  const title = current.title || "";
  const explicitToken = "(article:" + slug + ")";
  const out = [];
  const seen = new Set();

  for (const a of articles || []) {
    if (!a || a.slug === slug || seen.has(a.slug)) continue;
    if (a.status && a.status !== "published") continue;
    const md = a.content_markdown || "";
    if (md.indexOf(explicitToken) >= 0 || mentions(md, title)) {
      seen.add(a.slug);
      out.push({ slug: a.slug, title: a.title || a.slug });
      if (out.length >= limit) break;
    }
  }
  return out;
}

export function seeAlsoHTML(items) {
  if (!items || !items.length) return "";
  return `
    <nav class="mt-8 pt-5 border-t border-sage-100" aria-label="Mentioned in">
      <p class="text-xs font-semibold uppercase tracking-wide text-sage-400 mb-2">Mentioned in</p>
      <div class="flex flex-wrap gap-2">
        ${items
          .map(
            (it) => `<button data-article-link="${escapeHtml(it.slug)}" class="text-sm px-3 py-1.5 rounded-full bg-white border border-sage-200 text-sage-700 hover:border-sage-400">${escapeHtml(it.title)}</button>`
          )
          .join("")}
      </div>
    </nav>`;
}
